import i18n from 'app-i18n';

export const getCCNumberGCNumberText = (paymentType: string) => {
  if (paymentType === 'GIFT_CARD')
    return i18n.t('drawer.orderDetailsDrawer.gcNumber');
  if (paymentType === 'CARD_NOT_PRESENT')
    return i18n.t('drawer.orderDetailsDrawer.ccNumber');
  return '';
};
